/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Grid, Stack, Typography } from '@mui/material';
import SelectRelations from './Components/SelectRelation';
import SocialMedia from './Components/SocialMedia';
import MainCard from '../../../../../../UiComponents/Cards/MainCard';
import { LanguageContext } from '../../../../../../libs/Context';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { createFeedContext } from '../CreationPopup';
import { roleCondition } from '../../../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ShareCreation = (props:any) =>
{
	const { open, handleClose, relationsRef, departmentsRef, createFeedAs, requestT, socialAccounts, isSocialEnable } = props;
	const { language } = useContext(LanguageContext);
	const { createFeed, setCreateFeed } = useContext(createFeedContext);

	console.log('*************** is social media enable or disable:::', isSocialEnable, '\n social accounts:::', socialAccounts);
	const [ selectedMedia, setSelectedMedia ] = useState<any>(createFeed?.socialMedia ?? []);

	const userData = useSelector((state:any) => state?.mysession?.session);

	const [ updateReltns, setUpdateReltns ] = useState<any>([]);

	const updateData = useCallback(() =>
	{
		if (updateReltns?.length === 0)
		{
			toast.dismiss();
			toast.error(roleCondition(userData?.empRole) && createFeedAs === 'company' ? language?.selectOneBussRelation : 'Select at least one relation or department', {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else
		{
			setCreateFeed((prev) => ({ ...prev,
				relations   : updateReltns,
				socialMedia : selectedMedia // all social media removal fix
			}));
			handleClose();
		}
	}, [ updateReltns, selectedMedia ]);

	useEffect(() =>
	{
		const prevSelectedRelationsList = relationsRef?.current?.filter((dataD) => createFeed?.relations?.some((reltn) => reltn?.relationId === dataD?.relationId));

		const prevSelectedDeptList = departmentsRef?.current?.filter((department) => createFeed?.relations?.some((dept) => dept === `${userData?.companyId}-${department?.name}`))?.map((dept) => `${userData?.companyId}-${dept?.name}`);

		setUpdateReltns([ ...prevSelectedRelationsList, ...prevSelectedDeptList ]);
	}, [ createFeed?.relations ]);

	return (
		<>
			{/* As per the bugs number: #I12911 , I removed onClose={handleClose}, this for prevent when use click outside the dialog, or Esc key */}
			<Dialog open={open} maxWidth='sm' 	fullWidth>
				<DialogTitle sx={{ borderBottom: '1px solid var(--grayE0)' }}>
					<Stack direction='row' spacing={1}>
						<Typography fontWeight='var(--font500)'	sx={{ display: 'flex', alignItems: 'center' }}>
							<ArrowBackOutlinedIcon
								onClick={updateData}
								sx={{ cursor: 'pointer' }}
								fontSize='medium'
								role='button'
								tabIndex={0}
							/>
						</Typography>
						<Typography fontWeight={600}>Share</Typography>
					</Stack>
				</DialogTitle>
				<DialogContent >
					<Grid container p='var(--pixel8)' spacing={1.5} id='socialAccns'>
						{/* {(roleCondition(userData?.empRole) && createFeedAs === 'company') && */}
						<Grid item xs={12}>
							<MainCard sx={{ borderRadius: '13px', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px' }}>
								<SelectRelations
									updateReltns={updateReltns}
									setUpdateReltns={setUpdateReltns}
									relationsRef={relationsRef}
									departmentsRef={departmentsRef}
									createFeedAs={createFeedAs}
									userData={userData}
								/>
							</MainCard>
						</Grid>
						{/* } */}
						{createFeedAs !== 'self' &&
						<SocialMedia
							createFeedAs={createFeedAs}
							selectedMedia={selectedMedia}
							setSelectedMedia={setSelectedMedia}
							requestT={requestT}
							socialAccounts={socialAccounts}
							isSocialEnable={isSocialEnable}
						/>}
					</Grid>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default ShareCreation;